module.exports = __webpack_public_path__ + "img/Airbnb-Equipment-Chairs-Did-you-know_.fc09e151.jpg";